<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'menu.invoice.overview'|translate"
                [cardOptionBtn]="true"
                [cardRouterLink]="'/back-office/invoice/overview'"
                [title]="'global.overview'|translate">
        <app-grid [buttonViewChange]="false" [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.amount | BackofficeCurrency}}
</ng-template>
<a #downloadLink href="" download style="display: none"></a>
